module.exports = __webpack_public_path__ + "files/c4b1fbf77979b5db7f58d1c257383ef9.png";